import {
    TASKS_WORKFLOW_SET_LOADING,
    TASKS_WORKFLOW_SET_ERROR,
    TASKS_WORKFLOW_MAPPINGS_SET_DATA,
    TASK_WORKFLOW_MILESTONES_SET_LOADING,
    TASK_WORKFLOW_MILESTONES_SET_DATA,
    TASK_WORKFLOW_MILESTONES_SET_ERROR,
    TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_LOADING,
    TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_DATA,
    TASK_WORKFLOW_PERMISSIONS_SET_DATA,
    TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_ERROR,
    TASK_WORKFLOW_PERMISSIONS_SET_LOADING,
    TASK_WORKFLOW_PERMISSIONS_UPDATE_DATA,
    } from 'src/actions/constants';

const defaultState = {
  isLoading: false,
  taskWorkflows: [],
  workflowMilestonesData: [],
  milestonesDropdownData: [],
  workflowPermissionsData: [],
  permissionsUpdateData : {},
};

export default (state = defaultState, action) => {
    switch (action.type) {
      case TASKS_WORKFLOW_SET_LOADING: {
        return {
          ...state,
          isLoading: action.data,
        };
      }

      case TASKS_WORKFLOW_MAPPINGS_SET_DATA : {
        return {
          ...state,
          errorMessage: undefined,
          taskWorkflows: action.data || [],
        };
      }

      case TASK_WORKFLOW_MILESTONES_SET_LOADING: {
        return {
          ...state,
          milestonesLoading: action.data,
        };
      }

      case TASK_WORKFLOW_MILESTONES_SET_DATA : {
        return {
          ...state,
          errorMessage: undefined,
          workflowMilestonesData: action.data || [],
        };
      }

      case TASK_WORKFLOW_MILESTONES_DROPDOWN_SET_DATA : {
        return {
          ...state,
          errorMessage: undefined,
          milestonesDropdownData: action.data || [],
        };
      }

      case TASK_WORKFLOW_PERMISSIONS_SET_DATA : {
        return {
          ...state,
          errorMessage: undefined,
          workflowPermissionsData: action.data || [],
        };
      }

      case TASK_WORKFLOW_PERMISSIONS_SET_LOADING: {
        return {
          ...state,
          permissionsLoading: action.data,
        };
      }

      case TASK_WORKFLOW_PERMISSIONS_UPDATE_DATA : {
        return {
          ...state,
          permissionsUpdateData: action.data || [],
        };
      }
      
      default: return state;
    }
  };
  
